import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Axios from 'axios';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import styles, { useStyles } from './styles';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  onAddress: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  errMsg: PropTypes.string,
  touched: PropTypes.bool,
  invalid: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onGettingCoord: PropTypes.func,
  onClearCoord: PropTypes.func,
  disabled: PropTypes.bool,
  additionalRestrictions: PropTypes.shape(),
  filterType: PropTypes.string,
  initialValue: PropTypes.string,
};

const defaultProps = {
  value: '',
  onGettingCoord: () => {},
  onClearCoord: () => {},
};

export const JsonPlaceSearchFormField = props => {
  const {
    label,
    value,
    id,
    onChange,
    onBlur,
    onFocus,
    errMsg,
    touched,
    invalid,
    disabled,
    initialValue,
  } = props;
  // console.log('🚀 ~ file: index.js ~ line 61 ~ initialValue', initialValue);

  useEffect(() => {
    Axios.get(
      'https://jh-static-content.s3-ap-southeast-2.amazonaws.com/builder-static/storelist.json',
    ).then(data => {
      const filtered = data.data.filter(places => places.store_name);

      setPlaces(filtered);
      if (initialValue) {
        setSelectedPlace(initialValue);
        onChange(initialValue);
      }
    });
  }, []);

  const [places, setPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = React.useState('');
  const [inputValue, setInputValue] = useState(initialValue);
  const [isInvalidAddress, setIsInvalidAddress] = useState(false);
  const handleChange = (event, newValue) => {
    // console.log('Change');
    if (onChange) onChange(newValue);
    setSelectedPlace(newValue);
  };

  const handleBlur = () => {
    if (onBlur) onBlur(value);
  };

  useEffect(() => {
    const valueToSearch = inputValue || initialValue;
    const searchSuccess =
      _.findIndex(places, { store_name: valueToSearch }) > -1;
    const isInValid = valueToSearch && !searchSuccess;

    // console.log(
    //   '🚀 ~ file: index.js ~ line 83 ~ isValidAddress ~ isValid',
    //   isInValid,
    //   searchSuccess,
    //   inputValue,
    // );
    setIsInvalidAddress(isInValid);
  }, [places, inputValue]);

  const styleClasses = useStyles();
  return (
    <Autocomplete
      id={id}
      value={selectedPlace}
      inputValue={value}
      freeSolo
      onChange={handleChange}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        onChange(newInputValue);
      }}
      options={places}
      onBlur={handleBlur}
      onFocus={onFocus}
      touched={touched}
      invalid={invalid}
      errMsg={errMsg}
      disabled={disabled}
      getOptionLabel={option => option.store_name}
      renderInput={params => (
        <TextField
          {...params}
          id={id}
          label={label}
          onBlur={handleBlur}
          fullWidth
          touched={touched}
          onFocus={onFocus}
          InputLabelProps={{
            classes: {
              root: styleClasses.inputLabel,
              shrink: styleClasses.labelShrink,
              focused: 'focused',
              underline: styleClasses.inputUnderline,
            },
          }}
          error={touched && invalid}
          helperText={
            (touched && errMsg) ||
            (isInvalidAddress &&
              "Note: Can't find your preferred partner? Just type your partner name and location.")
          }
        />
      )}
    />
  );
};

JsonPlaceSearchFormField.propTypes = propTypes;
JsonPlaceSearchFormField.defaultProps = defaultProps;

export default withStyles(styles)(JsonPlaceSearchFormField);
